module.exports = __webpack_public_path__ + "static/media/logo-laviana.ee8f7f7d.jpg";